/**
 * ArticlesProvider
 * Contain most logic handling with Omnitech Api
 */

import React from 'react'

import ArticlesContext from './articles-context'
import { fetchArticles, fetchArticle, fetchArticlesTags } from './articles-api'

export default function ArticlesProvider({ children }) {
  const state = {
    fetchArticles,
    fetchArticle,
    fetchArticlesTags
  }

  return (
    <ArticlesContext.Provider value={state}>
      {children}
    </ArticlesContext.Provider>
  )
}
